import { canAccessAdminRoutesWithSuperAdmin, isSuperAdminRouteGuard } from '@/utils/routeGuards';
import { isGranularPermissionsEnabled } from '@/utils/granularPermissionsFlag';

import type { RouteRecordRaw } from 'vue-router';

/**
 * Returns the Settings → User Permissions route component based on the
 * session-pinned granular-permissions flag. Flag-off keeps today's
 * UserPermissions.vue; flag-on loads the new shell. Prefer this over
 * requiredLDFlags, which can only deny to NoAccess and cannot fall back
 * to the legacy view.
 */
export const getSettingsUserPermissionsComponent = () => {
  if (isGranularPermissionsEnabled()) {
    return import('@/components/settings/UserPermissionsView.vue');
  }

  return import('@/views/UserPermissions.vue');
};

const routes: RouteRecordRaw[] = [
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/SettingsPage.vue'),
    redirect: { name: 'SettingsScholarships' },
    children: [
      {
        path: 'scholarships/:pathMatch(.*)*',
        name: 'SettingsScholarships',
        component: () => import('@/views/SettingsScholarships.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
        beforeEnter: [canAccessAdminRoutesWithSuperAdmin],
      },
      {
        path: 'contracts/:pathMatch(.*)*',
        name: 'SettingsContractTemplates',
        component: () => import('@/views/SettingsContractTemplates.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
        beforeEnter: [canAccessAdminRoutesWithSuperAdmin],
      },
      {
        path: 'user-permissions/:pathMatch(.*)*',
        name: 'SettingsUserPermissions',
        component: getSettingsUserPermissionsComponent,
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
        beforeEnter: [isSuperAdminRouteGuard],
      },
      {
        path: 'notifications',
        name: 'SettingsNotifications',
        component: () => import('@/views/SettingsNotifications.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          layoutOptions: {
            noAppBarBorder: true,
          },
          requiresAuth: true,
          title: 'pageSettings.metaTitle',
        },
      },
    ],
  },
];


export default routes;
